import { render, staticRenderFns } from "./nav-save-indicator.vue?vue&type=template&id=07472338&scoped=true&"
import script from "./nav-save-indicator.vue?vue&type=script&lang=ts&"
export * from "./nav-save-indicator.vue?vue&type=script&lang=ts&"
import style0 from "./nav-save-indicator.vue?vue&type=style&index=0&id=07472338&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07472338",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
